import React, { useEffect } from "react";
import "./For_support.css";
import Common_Title from "../common_components/common_title/Common_Title";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const For_support = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section className="For_support_sec">
        <div className="container">
          <div className="row justify-content-center" >
            <div className="col-lg-7  mt-auto mb-lg-0 mb-3 order-lg-1 order-2 ">
              <div className="title_holder">
                <Common_Title simpleText="Talk to " darkText="Our Experts " />
              </div>
              <div className="support-box">
                <p className="supobox">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/home/support/headphones-alt.png"
                    }
                  />{" "}
                  for Support
                </p>

                <div className="row mb-3">
                  <div className="col-6">
                    <p className="supp">
                      <img
                        className="icon"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/support/partner.png"
                        }
                      />
                      To Be a Partner :
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="supp">1800-267-8961</p>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-6">
                    <p className="supp">
                      <img
                        className="icon"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/support/call.png"
                        }
                      />
                      Existing Partner :
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="supp">1800-267-8961</p>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-6">
                    <p className="supp">
                      <img
                        className="icon"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/support/email.png"
                        }
                      />
                      E-mail :
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="supp">inquiry@profcyma.com</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-sm-8 col-10 order-lg-2 order-1">
              <Swiper
                className="mySwiper "
                spaceBetween={5}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: true,
                }}
                modules={[Autoplay]}
              >
                <SwiperSlide>
                  <div className="img_div">
                    <img
                      className="supimg"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/home/support/img_1.png"
                      }
                    />
                  </div>
                </SwiperSlide>


                 

                <SwiperSlide>
                  <div className="img_div">
                    <img
                      className="supimg"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/home/support/img_3.png"
                      }
                    />
                  </div>
                </SwiperSlide>



              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default For_support;
